import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
    <path d="M4.5 12c-.8 0-1.5.7-1.5 1.5S3.7 15 4.5 15 6 14.3 6 13.5 5.3 12 4.5 12zM0 0v1.5h1.5l2.7 5.7-1 1.8c-.1.2-.2.5-.2.8 0 .8.7 1.5 1.5 1.5h9V9.8H4.8c-.1 0-.2-.1-.2-.2v-.1l.7-1.2h5.6c.6 0 1.1-.3 1.3-.8l2.7-4.9c.1-.1.1-.2.1-.3 0-.4-.3-.8-.8-.8h-11L2.5 0H0zm12 12c-.8 0-1.5.7-1.5 1.5S11.2 15 12 15s1.5-.7 1.5-1.5S12.8 12 12 12z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/icon-cart.es6.js